export interface IDefaults {
    controlName: string;
    controlValue: any;
}